import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const BLUE = '#1F4E79';
const bar = { background: BLUE, color: '#fff', fontWeight: 'bold', padding: '3px 6px' };

/**
 * HTML preview of AUTOSUR's "Vale de resguardo de artículos" in the signing
 * modals (asset detail and Reportes > Vales de resguardo): a PDF in an <iframe>
 * does not show on Android Chrome. It paints custodyVoucherPreview
 * (lib/pdfs/autosur), the same texts as the paper PDF; the table scrolls
 * sideways on a phone. The SAAF logo of the footer loads on demand, as the PDF's.
 */
class AutosurVoucherPreview extends PureComponent {
  static propTypes = { preview: PropTypes.object.isRequired };

  state = { logoSaaf: null };

  componentDidMount = () => {
    import('lib/pdfs/logo').then(({ LOGO }) => {
      if (!this.unmounted) this.setState({ logoSaaf: LOGO });
    });
  };

  componentWillUnmount = () => {
    this.unmounted = true;
  };

  render = () => {
    const p = this.props.preview;
    return (
      <div className="border rounded p-3 mb-3 small" style={{ background: '#fff' }}>
        <div className="d-flex align-items-center mb-2 p-2" style={{ background: '#F2F2F2' }}>
          <div className="flex-fill text-center font-weight-bold" style={{ color: BLUE }}>
            {p.title}
          </div>
          <div className="text-center font-weight-bold" style={{ color: '#333' }}>
            Folio:
            <br />
            {p.folio}
          </div>
        </div>

        <div style={bar}>1. DATOS DEL COLABORADOR</div>
        <div className="row no-gutters p-2 mb-2" style={{ background: '#D9EAF7', color: BLUE }}>
          {p.collaborator.map(([label, value]) => (
            <div key={label} className="col-sm-6">
              <b>{label}</b> {value}
            </div>
          ))}
        </div>

        <div style={bar}>2. ARTÍCULOS ENTREGADOS</div>
        <div className="table-responsive mb-2">
          <table className="table table-sm table-striped mb-0" style={{ color: '#45535b' }}>
            <thead>
              <tr>
                {p.headers.map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {p.items.map((cells, row) => (
                <tr key={row}>
                  {cells.map((lines, column) => (
                    <td key={column}>
                      {lines.map((line, i) => (
                        <div key={i}>{line}</div>
                      ))}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={bar}>3. DECLARACIÓN DE RESGUARDO</div>
        <p className="my-2" style={{ textAlign: 'justify' }}>
          {p.declaration}
        </p>

        <div style={bar}>4. FIRMAS DE ENTREGA Y RECEPCION</div>
        <div className="row no-gutters text-center border mt-2">
          <div className="col-6 border-right p-2">
            <div className="font-weight-bold">ENTREGA</div>
            <div>{p.delivered}</div>
            <div>{p.blankDate}</div>
          </div>
          <div className="col-6 p-2">
            <div className="font-weight-bold">RECIBE</div>
            <div>{p.received}</div>
            <div>{p.blankDate}</div>
          </div>
        </div>

        <div className="d-flex align-items-end mt-3">
          <div className="flex-fill text-center" style={{ fontSize: 10, color: '#646464' }}>
            {p.footer}
          </div>
          {this.state.logoSaaf && (
            <div className="text-right">
              <div style={{ fontSize: 8, color: '#9aa5ad' }}>Generado por</div>
              <img src={this.state.logoSaaf} alt="SAAF" style={{ width: 45, opacity: 0.55 }} />
            </div>
          )}
        </div>
      </div>
    );
  };
}

export default AutosurVoucherPreview;



// WEBPACK FOOTER //
// src/modules/common/components/AutosurVoucherPreview.js